/* External dependencies */
import { AnyAction } from 'redux';

/* Local dependencies */
import { VerifyDeviceInput, Device } from '../../types';

export enum VerifyDeviceActionTypes {
  VERIFY_DEVICE_REQUEST = 'VERIFY_DEVICE_REQUEST',
  VERIFY_DEVICE_SUCCESS = 'VERIFY_DEVICE_SUCCESS',
  VERIFY_DEVICE_FAILURE = 'VERIFY_DEVICE_FAILURE',
}

export interface VerifyDeviceAction extends AnyAction {
  type: VerifyDeviceActionTypes.VERIFY_DEVICE_REQUEST;
  payload: VerifyDeviceInput;
}

export interface VerifyDeviceSuccessAction extends AnyAction {
  type: VerifyDeviceActionTypes.VERIFY_DEVICE_SUCCESS;
  payload: Device;
}

export interface VerifyDeviceFailureAction extends AnyAction {
  type: VerifyDeviceActionTypes.VERIFY_DEVICE_FAILURE;
  payload: Error;
}

export const verifyDeviceAction = (input: VerifyDeviceInput): VerifyDeviceAction => ({
  type: VerifyDeviceActionTypes.VERIFY_DEVICE_REQUEST,
  payload: input,
});

export const verifyDeviceSuccess = (device: Device): VerifyDeviceSuccessAction => ({
  type: VerifyDeviceActionTypes.VERIFY_DEVICE_SUCCESS,
  payload: device,
});

export const verifyDeviceFailure = (error: Error): VerifyDeviceFailureAction => ({
  type: VerifyDeviceActionTypes.VERIFY_DEVICE_FAILURE,
  payload: error,
}); 